var render = function render(){var _vm=this,_c=_vm._self._c;return _c('medication-allergies-template',{attrs:{"medication-allergies":_vm.medicationAllergies,"other-medication-allergies":_vm.otherMedicationAllergies,"medication-tetracyclin-visible":_vm.medicationTetracyclinVisible,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }